<template>
    <div>
        <QBtn
            ref="userAvatar"
            color="primary"
            flat
            noCaps
            class="q-mr-sm"
            :aria-label="$t('general.account')"
        >
            <QAvatar rounded color="primary" textColor="white" size="32px">
                {{ initialName }}
            </QAvatar>
            <QTooltip v-if="hideFullName">
                {{ fullName }}
            </QTooltip>
            <span
                v-if="!hideFullName"
                class="q-ml-sm text-weight-medium text-body1 ellipsis"
                style="max-width: 120px;"
            >
                {{ fullName }}
            </span>
            <QMenu
                :anchor="directionAnchor"
                :self="directionSelf"
                transitionShow="jump-down"
                transitionHide="jump-up"
            >
                <QList style="min-width: 180px;">
                    <QItem v-close-popup clickable @click="handleClickAction({ key: ACTIONS.ACCOUNT })">
                        <QItemSection avatar>
                            <QIcon name="person" color="primary" />
                        </QItemSection>
                        <QItemSection>{{ $t('general.account') }}</QItemSection>
                    </QItem>
                    <QItem v-close-popup clickable @click="handleClickAction({ key: ACTIONS.DOC })">
                        <QItemSection avatar>
                            <QIcon name="code" color="primary" />
                        </QItemSection>
                        <QItemSection>{{ $t('general.apis') }}</QItemSection>
                    </QItem>
                    <QSeparator />
                    <QItem v-close-popup clickable @click="handleClickAction({ key: ACTIONS.SIGNOUT })">
                        <QItemSection avatar>
                            <QIcon name="logout" color="negative" />
                        </QItemSection>
                        <QItemSection>{{ $t('general.signout') }}</QItemSection>
                    </QItem>
                </QList>
            </QMenu>
        </QBtn>
    </div>
</template>

<script>
import {
    QBtn, QAvatar, QMenu, QList, QItem, QItemSection, QIcon, QTooltip, QSeparator,
} from 'quasar'
import VueTypes from 'vue-types'

export default {
    name: 'UserAvatar',
    components: {
        QBtn, QAvatar, QMenu, QList, QItem, QItemSection, QIcon, QTooltip, QSeparator,
    },
    inject: ['App'],
    props: {
        direction: VueTypes.string.def('top-right'),
        hideFullName: VueTypes.bool.def(false),
    },
    data() {
        return {
            ACTIONS: {
                ACCOUNT: 'ACCOUNT',
                DOC: 'DOC',
                SIGNOUT: 'SIGNOUT',
            },
        }
    },
    computed: {
        initialName() {
            const [letter] = this.fullName || ''
            return letter || 'U'
        },
        fullName() {
            const { name } = this.App?.user || {}
            return name || ''
        },
        directionAnchor() {
            return this.direction === 'top-right' ? 'bottom right' : 'bottom left'
        },
        directionSelf() {
            return this.direction === 'top-right' ? 'top right' : 'top left'
        },
    },
    methods: {
        handleClickAction({ key }) {
            const actions = {
                [this.ACTIONS.ACCOUNT]: () => this.navigateAndCloseDropdown({ name: 'Account' }),
                [this.ACTIONS.DOC]: () => this.navigateAndCloseDropdown({ name: 'Doc' }),
                [this.ACTIONS.SIGNOUT]: this.signOutAndCloseDropdown,
            }
            if (actions[key]) actions[key]()
        },
        navigateAndCloseDropdown(route) {
            this.$router.push(route).then(() => {
            }).catch(() => {})
        },
        signOutAndCloseDropdown() {
            this.App.signout()
        },
    },
}
</script>
